import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { BackButton } from "../../ui/BackButton";
import { cn } from "../../../lib/utils";

export default function ContentHeader({
  backLabel,
  backTo,
  onBack,
  title,
  actions,
  transparent = false,
  contentColor = "dark",
  className,
}: {
  backLabel?: string;
  backTo?: string | { pathname: string; state?: unknown };
  onBack?: () => void;
  title?: string;
  actions?: ReactNode;
  transparent?: boolean;
  /** Tone of the back label + action icons — flip to "light" over dark art. */
  contentColor?: "dark" | "light";
  className?: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const isLight = contentColor === "light";

  return (
    <div
      className={cn(
        "px-3.5 py-3 md:hidden border-b border-secondary-soft-yellow-grey",
        transparent ? "bg-transparent" : "bg-white/10 backdrop-blur-md",
        className
      )}
    >
      <div className="relative flex items-center justify-between">
        <BackButton
          to={backTo}
          onClick={onBack}
          className={cn("z-10", isLight ? "text-white" : "")}
        >
          {backLabel ?? t("Back")}
        </BackButton>
        {title !== undefined && (
          <span
            className={cn(
              "absolute left-1/2 -translate-x-1/2 max-w-[55%] truncate text-center text-base font-medium",
              isLight ? "text-white" : "text-secondary-bluegrey-7"
            )}
          >
            {title}
          </span>
        )}
        <div
          className={cn(
            "z-10 flex items-center gap-4",
            // Action icons carry hard-coded dark fills; invert them to white so
            // they read over dark art without touching the shared icon SVGs.
            isLight ? "[&_svg]:brightness-0 [&_svg]:invert" : ""
          )}
        >
          {actions}
        </div>
      </div>
    </div>
  );
}
